import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import RegisterView from '@/views/RegisterView.vue';

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'home',
		component: HomeView,
	},
	{
		path: '/item/:itemId',
		name: 'item',
		component: HomeView,
	},
	{
		path: '/register',
		name: 'register',
		component: RegisterView,
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

export default router;
